interface ButtonProps {
  onClick?: (event: any) => void
  icon?: JSX.Element
  text: string
  color?: 'black' | 'white'
  border?: boolean
  className?: string
  disabled?: boolean
  iconposition?: 'left' | 'right'
}

export const Button = ({
  icon,
  iconposition = 'right',
  onClick,
  text,
  color = 'black',
  border = true,
  className = '',
  disabled = false,
}: ButtonProps) => {
  const colorClass = color === 'black' ? 'btn-black' : 'btn-white'
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`
        flex h-10 min-w-24 items-center justify-center gap-2 px-4 py-2 ${colorClass} ${border ? 'border border-solid' : ''} body-s font-bold whitespace-nowrap ${className}`}
    >
      {iconposition === 'left' && icon}
      {text}
      {iconposition === 'right' && icon}
    </button>
  )
}
